import styled from "styled-components";

export const StatusShowInfoStyled = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  .status_color {
    border: 2px solid ${({ theme }) => theme.COLORS.GRAY_8};
    width: 20px;
    height: 20px;
    background-color: ${({ theme, color }) => color || theme.COLORS.GREEN_2};
  }
  .status_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    color: ${({ theme }) => theme.COLORS.BLACK_1};
  }

  .theme_standard {
  }
`;
